
import BagTick from "../../../assets/duotone/BagTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BagTickIcon({ className, dataTestid = "BagTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BagTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
